import { render, staticRenderFns } from "./NewUserPassword.vue?vue&type=template&id=24876f82&scoped=true&"
import script from "./NewUserPassword.vue?vue&type=script&lang=js&"
export * from "./NewUserPassword.vue?vue&type=script&lang=js&"
import style0 from "./NewUserPassword.vue?vue&type=style&index=0&id=24876f82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24876f82",
  null
  
)

export default component.exports